import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './Header.css';

const Header: React.FC = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isClicked, setIsClicked] = useState(false);
  const navigate = useNavigate();

  const handleNameClick = () => {
    navigate('/');
  };

  const handleCvClick = () => {
    window.open('/CV.pdf', '_blank');
    setIsMenuOpen(false);
  };

  const handleFrequencyClick = () => {
    navigate('/frequency');
    setIsMenuOpen(false);
  };

  const handleRobotClick = () => {
    setIsMenuOpen(!isMenuOpen);
    setIsClicked(true);
    setTimeout(() => setIsClicked(false), 500); // Reset after animation
  };

  return (
    <header className="header">
      <div className="header-content">
        <h1 className="header-name" onClick={handleNameClick}>
          Denis Hadjivelichkov
        </h1>
        <div className="header-right">
          <div className="robot-menu">
            <span 
              className={`robot-emoji ${isClicked ? 'clicked' : ''}`}
              onClick={handleRobotClick}
            >
              🤖
            </span>
            {isMenuOpen && (
              <div className="dropdown-menu">
                <div className="dropdown-item" onClick={handleCvClick}>
                  CV
                </div>
                <div className="dropdown-item" onClick={handleFrequencyClick}>
                  Frequency
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header; 